/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOf
 */
export interface BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOf
     */
    'cardType': BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOf
     */
    'expiredDate': string;
}

export const BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = typeof BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOfCardTypeEnum[keyof typeof BulkDisableDailyUserUsageLimit200ResponseInnerReissueOneOfCardTypeEnum];


